module.exports = __webpack_public_path__ + "img/ios-return-right.7970de06.svg";